import {Logger} from '#core/utils/logger.js';
import {deepFreezeAllEnumerables} from '#core/utils/config-utils.js';

import {PaletteRetriever} from '#core/application/modules/palette-retriever.js';

import {registerPaletteSchema} from '../schema-registry.js';

import BASE_PALETTE_SCHEMA from './base.palette-schema.yaml';

const log = Logger('BasePalette');

export const BasePalette = {
    palette: {},

    load: function (config) {
        let validator = new PaletteRetriever(log);
        validator.constructPaletteBySchema(config, BASE_PALETTE_SCHEMA);
        this.palette = validator.intermediateCache; // not resulted palette, but with dark/light colors
        process.env.NODE_ENV === 'development' && deepFreezeAllEnumerables(this.palette);
    },
};

registerPaletteSchema(BASE_PALETTE_SCHEMA);
